import { Check } from './Chrome'
import BuyButton from './BuyButton'
import { downloadURL, priceLabel } from '../lib/firebase'
import { useT } from '../i18n'

/**
 * Tarifs : deux cartes, deux listes.
 *
 * Le nom de l'offre est un intitulé, pas une pastille étirée : dans une carte
 * en flex-column, tout enfant s'étire sur la largeur si on ne l'en empêche pas.
 */
export default function Pricing() {
  const t = useT()

  return (
    <section id="pricing">
      <div className="section-head">
        <h2>{t.pricing.heading}</h2>
        <p>{t.pricing.sub}</p>
      </div>

      <div className="plans">
        <article className="card plan">
          <header className="plan-head">
            <h3>{t.pricing.free}</h3>
            <p className="plan-price">{t.pricing.freePrice}</p>
            <p className="plan-sub">{t.pricing.freeSub}</p>
          </header>
          <ul>{t.pricing.freeList.map((i) => <li key={i}><Check />{i}</li>)}</ul>
          <a className="btn btn-ghost btn-block" href={downloadURL}>{t.pricing.download}</a>
          <p className="plan-foot">{t.pricing.freeFoot}</p>
        </article>

        <article className="card plan is-featured">
          <span className="plan-ribbon">{t.pricing.ribbon}</span>
          <header className="plan-head">
            <h3>{t.pricing.pro}</h3>
            <p className="plan-price">{priceLabel} <span>{t.pricing.once}</span></p>
            <p className="plan-sub">{t.pricing.proSub}</p>
          </header>
          <ul>{t.pricing.proList.map((i) => <li key={i}><Check />{i}</li>)}</ul>
          <BuyButton className="btn btn-primary btn-block" />
        </article>
      </div>
    </section>
  )
}
